<script >
import $t from '../common/i18n';
import useStockQuote from '../composables/useStockQuote';
import useUserWch from '../composables/useUserWch';
import useUpDownType from '../composables/useUpDownType';
import { getSchemeLink } from '../common/scheme';
import { computed } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  stockId: Number,
  upDownType: Number,
  increaseType: String,
  textColor: String,
  tagList: Array,
  schemeType: String
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    loaded,
    stockQuote
  } = useStockQuote(props);
  const {
    selectedStatus,
    setSelectStatus
  } = useUserWch(props.stockId);
  const {
    upDownTypeCls
  } = useUpDownType(props);

  // css变量 控制文本颜色
  const cssVar = computed(() => ({
    '--card-text-color': props.textColor
  }));

  // 点击跳转
  const {
    useBehaviour
  } = require('@fegobull/webapi').use;
  const {
    runBehaviour
  } = useBehaviour();
  const onClick = $event => {
    if (!props.schemeType) return;
    const link = getSchemeLink(props.stockId, props.schemeType);
    link && runBehaviour(null, {
      type: 'jump',
      value: link
    }, $event);
  };
  return {
    $t,
    loaded,
    stockQuote,
    selectedStatus,
    setSelectStatus,
    upDownTypeCls,
    cssVar,
    onClick
  };
};
export default __sfc_main;
</script>
<template>
    <div class="quotes-card-v3" :class="{ loading: !loaded }" :style="cssVar" @click="onClick">
        <div class="header-block">
            <div class="stock-info">
                <p class="stock-info__name over-text">{{ stockQuote.name }}</p>
                <img
                    v-if="selectedStatus"
                    class="wch-icon"
                    src="../images/added-wch.png"
                    @click.stop="setSelectStatus($event, false)"
                    alt="added"
                />
                <svg
                    v-else
                    class="wch-icon"
                    @click.stop="setSelectStatus($event, true)"
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.0821 10.924C16.3662 7.45135 10.6712 7.74616 7.33364 11.584C3.9686 15.4534 4.27903 21.45 8.02562 24.9513L23.3949 39.3144C23.5472 39.4567 23.7263 39.5103 23.8944 39.4984L24.0009 39.4908L24.1075 39.4984C24.2755 39.5104 24.4546 39.4567 24.6068 39.3144L28.4271 35.7442L30.5497 37.8668L26.6552 41.5063C25.9088 42.2038 24.9497 42.5364 24.0009 42.4968C23.0521 42.5364 22.093 42.2038 21.3466 41.5063L5.97726 27.1432C1.05066 22.5391 0.645033 14.7035 5.06991 9.61533C9.5223 4.49555 17.1733 4.09949 22.1305 8.73217L21.1063 9.8281L22.1305 8.73217L24.0013 10.4805L25.8719 8.7324C30.829 4.09983 38.4798 4.49588 42.9321 9.61554C46.2444 13.4244 46.8499 18.7728 44.8783 23.1528L42.5559 20.8304C43.5268 17.7198 42.9215 14.1751 40.6683 11.5842C37.3309 7.74649 31.6361 7.45169 27.9202 10.9243L25.0255 13.6295L24.0013 14.5866L22.9771 13.6295L20.0821 10.924ZM36.8778 39.0586V37.5586V32.2773H31.5986H30.0986V29.2773H31.5986H36.8778V24V22.5H39.8778V24V29.2773H45.1571H46.6571V32.2773H45.1571H39.8778V37.5586V39.0586H36.8778Z"
                        :fill="textColor"
                    />
                </svg>
            </div>
            <p class="tag-ls">
                <span class="tag-ls__item" v-for="tag in tagList" :key="tag">
                    {{ tag.tagText }}
                </span>
            </p>
        </div>
        <div class="stock-quote">
            <p
                :class="[
                    'stock-quote__increase-rate',
                    upDownTypeCls,
                    {
                        up: stockQuote.rate > 0,
                        down: stockQuote.rate < 0
                    }
                ]"
            >
                {{ stockQuote.rateStr }}
            </p>
            <p class="stock-quote__increase-type">{{ $t(increaseType) }}</p>
        </div>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
